import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.timers.js";
import { loadStripe } from '@stripe/stripe-js';
'use strict';
// var localStorage = window.localStorage;
export default {
  name: 'UpgradeMembership',
  components: {},
  props: {},
  watch: {
    "showUpgradeMembershipPage": function showUpgradeMembershipPage(newValue) {
      if (newValue === true) {
        if (!this.$store.state.suppressSecondaryActions) {
          this.$store.commit('updateSuppressSecondaryActions', false);
          this.$store.dispatch('reportEvent', 'show_upgrade_screen');
        }
      }
    },
    "$store.state.proMembership": function $storeStateProMembership(newValue) {
      if (newValue === true) {
        this.$store.commit('updateShowUpgradeMembershipPage', false);
        this.$store.commit('updateLimitReached', false);
      }
    },
    "$store.state.basicMembership": function $storeStateBasicMembership(newValue) {
      if (newValue === true) {
        this.$store.commit('updateShowUpgradeMembershipPage', false);
        this.$store.commit('updateLimitReached', false);
      }
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.$store.commit('updateHideBluetoothController', true);
            if (_this.$store.state.proMembership || _this.$store.state.basicMembership) {
              _this.$store.commit('updateShowUpgradeMembershipPage', false);
              _this.$store.commit('updateLimitReached', false);
            }
            if (_this.$store.state.basicMembership === true || _this.$store.state.basicMembership === 'true') {
              _this.hideBasicMembership();
            }
            if (_this.$store.state.appType == 'Web') {
              _this.monthlySelected = true;
            }
            if (_this.monthlySale) {
              setTimeout(function () {
                _this.monthlySelected = true;
              }, 1000);
            }
            // if (window.getDigitalGoodsService) {
            //   this.error = 'top'
            //   var service = await window.getDigitalGoodsService("https://play.google.com/billing");
            //   service.consume('kejbkockigmmgbhmicljmgok.AO-J1OyGjpQMAHV0LtDNDN4CFcZ6qjn28bpXCE45ogBgAO0EH7RKdJ56_99ao0s5Dlrq0ZCT-wW1_y_bHcYlR_7gfN0ielFqkPadu7zJHqZmXQ41bArN_ZE')
            //   service.consume('jimfhmocfeemjdhohcgjfalo.AO-J1Ox0f5e9BRg08B7kKQHEPjZ_cjiMGAlZmG93jaoKg0pvbp9yp0dXkbKYtBDlDSyQjv7-hQSKJc_-IQufAa1zoXi6nisq2ld-Y-oUY1m-kvlV2eIdIGI')

            // }
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    checkout: function checkout() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var stripe, clientReferenceId, response, session, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return loadStripe('pk_live_dGkHeo9UEfncRmeOyiobhE5d');
            case 2:
              stripe = _context2.sent;
              clientReferenceId = _this2.$store.state.userUID; // Generate or retrieve your unique ID
              _context2.next = 6;
              return fetch('https://us-central1-ai-voice-chat-358705.cloudfunctions.net/stripePaymentIntent', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  clientReferenceId: clientReferenceId
                }) // Send the unique ID to the server
              });
            case 6:
              response = _context2.sent;
              _context2.next = 9;
              return response.json();
            case 9:
              session = _context2.sent;
              _context2.next = 12;
              return stripe.redirectToCheckout({
                sessionId: session.id
              });
            case 12:
              result = _context2.sent;
              if (result.error) {
                console.error(result.error.message);
              }
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    hideBasicMembership: function hideBasicMembership() {
      this.showMonthlyMembership = false;
    },
    upgradeToPro: function upgradeToPro() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var service, details, paymentMethodData, request, paymentResponse, purchaseToken, paymentComplete, axios, qs, userToken, data, config, localThis;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!('getDigitalGoodsService' in window)) {
                _context5.next = 25;
                break;
              }
              _context5.next = 3;
              return window.getDigitalGoodsService("https://play.google.com/billing");
            case 3:
              service = _context5.sent;
              _context5.next = 6;
              return service.getDetails(['pro_membership']);
            case 6:
              details = _context5.sent;
              _this3.ResponseFromPurchase = JSON.stringify(details);
              _this3.error = JSON.stringify(details);
              // const item = details[0];
              paymentMethodData = [{
                supportedMethods: 'https://play.google.com/billing',
                data: {
                  sku: 'pro_membership' //item.itemId,
                }
              }];
              request = new PaymentRequest(paymentMethodData);
              _this3.error = 'requested';
              _context5.next = 14;
              return request.show();
            case 14:
              paymentResponse = _context5.sent;
              _this3.ResponseFromPurchase = JSON.stringify(paymentResponse);
              _this3.error = _this3.ResponseFromPurchase;
              purchaseToken = paymentResponse.details.purchaseToken;
              axios = require('axios');
              qs = require('qs');
              userToken = localStorage.getItem('security');
              data = qs.stringify({
                token: purchaseToken,
                itemID: 'pro_membership',
                type: 'subscription',
                userToken: userToken
              });
              config = {
                method: 'post',
                url: process.env.VUE_APP_ENVIRONMENT !== 'development' ? 'https://us-central1-ai-voice-chat-358705.cloudfunctions.net/upgradePro' : 'https://us-central1-ai-voice-chat-358705.cloudfunctions.net/upgradePro',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: data
              };
              localThis = _this3;
              axios(config).then( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(response) {
                  var message;
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        message = response.data;
                        console.log('message', message);
                        if (!(message.success === true)) {
                          _context3.next = 13;
                          break;
                        }
                        _context3.next = 5;
                        return paymentResponse.complete('success');
                      case 5:
                        paymentComplete = _context3.sent;
                        localThis.$store.commit("updateShowUpgradeMembershipPage", false);
                        localThis.$store.commit('updateLimitReached', false);
                        localThis.$store.commit('showSnackbarInfo', 'Subscription Activated');
                        setTimeout(function () {
                          localThis.$store.commit('updateShowHearts', true);
                        }, 10);
                        setTimeout(function () {
                          localThis.$store.commit('updateShowHearts', false);
                        }, 4000);
                        _context3.next = 17;
                        break;
                      case 13:
                        _context3.next = 15;
                        return paymentResponse.complete('fail');
                      case 15:
                        paymentComplete = _context3.sent;
                        localThis.$store.state.showSnackbarWarning(message.message);
                      case 17:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }())["catch"]( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(error) {
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        _context4.next = 2;
                        return paymentResponse.complete('fail');
                      case 2:
                        paymentComplete = _context4.sent;
                        localThis.$store.state.showSnackbarWarning('There was an issue processing your transaction');
                        console.log(error);
                        console.log(paymentComplete);
                      case 6:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
              // let paymentComplete;
              // if (validatePurchaseOnBackend(purchaseToken)) {
              //   paymentComplete = await paymentResponse.complete('success');
              //   // Let user know their purchase transaction has successfully completed and been verified
              // } else {
              //   paymentComplete = await paymentResponse.complete('fail');
              //   // Let user know their purchase transaction failed to verify
              // }

              // this.paymentComplete = paymentComplete;

              // service.consume(purchaseToken);
            case 25:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    getPrettyNextPackage: function getPrettyNextPackage() {
      var nextPackage = this.$store.state.nextPackage;
      if (!nextPackage) {
        nextPackage = 'basic_tier';
      }
      if (nextPackage === 'basic tier') {
        return 'a Monthly Subscription';
      } else if (nextPackage === 'extended_tier') {
        return 'a Premium Subscription';
      } else {
        // do nothing
      }
    },
    updateNextPackage: function updateNextPackage(nextPackage) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var service, details, paymentMethodData, request, paymentResponse, purchaseToken, paymentComplete, axios, qs, userToken, data, config, localThis;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!('getDigitalGoodsService' in window)) {
                _context8.next = 28;
                break;
              }
              _this4.error = 'top';
              _context8.next = 4;
              return window.getDigitalGoodsService("https://play.google.com/billing");
            case 4:
              service = _context8.sent;
              //  service.consume('opapbklkjaamhagddmcapbkn.AO-J1OxpgH42HFD2TiUDCPDI2AXPupOO001-bEuqLzwm_ZfsaRg2rv8FupnYii0wQgWTvepBbbg5aCqhBB7AQqpR2U2-AK9SfoHH7tAw1alZcU0DVL3029s')
              _this4.error = 'service';
              _context8.next = 8;
              return service.getDetails([nextPackage]);
            case 8:
              details = _context8.sent;
              _this4.error = 'details';
              _this4.ResponseFromPurchase = JSON.stringify(details);
              _this4.error = JSON.stringify(details);
              // const item = details[0];
              paymentMethodData = [{
                supportedMethods: 'https://play.google.com/billing',
                data: {
                  sku: nextPackage //item.itemId,
                }
              }];
              request = new PaymentRequest(paymentMethodData);
              _this4.error = 'requested';
              _context8.next = 17;
              return request.show();
            case 17:
              paymentResponse = _context8.sent;
              _this4.ResponseFromPurchase = JSON.stringify(paymentResponse);
              _this4.error = _this4.ResponseFromPurchase;
              purchaseToken = paymentResponse.details.purchaseToken;
              axios = require('axios');
              qs = require('qs');
              userToken = localStorage.getItem('security');
              data = qs.stringify({
                token: purchaseToken,
                itemID: nextPackage,
                type: 'subscription',
                userToken: userToken
              });
              config = {
                method: 'post',
                url: process.env.VUE_APP_ENVIRONMENT !== 'development' ? 'https://us-central1-ai-voice-chat-358705.cloudfunctions.net/upgradePro' : 'https://us-central1-ai-voice-chat-358705.cloudfunctions.net/upgradePro',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: data
              };
              localThis = _this4;
              axios(config).then( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(response) {
                  var message;
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        message = response.data;
                        console.log('message', message);
                        _context6.next = 4;
                        return paymentResponse.complete('success');
                      case 4:
                        paymentComplete = _context6.sent;
                        service.consume(purchaseToken);
                        console.log(paymentComplete);
                        setTimeout(function () {
                          localThis.$store.commit('updateShowHearts', true);
                        }, 10);
                        setTimeout(function () {
                          localThis.$store.commit('updateShowHearts', false);
                        }, 4000);
                      case 9:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }())["catch"]( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(error) {
                  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        // REMOVE THIS LATER!!
                        service.consume(purchaseToken);
                        _context7.next = 3;
                        return paymentResponse.complete('fail');
                      case 3:
                        paymentComplete = _context7.sent;
                        console.log(error);
                        console.log(paymentComplete);
                      case 6:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                return function (_x4) {
                  return _ref4.apply(this, arguments);
                };
              }());
              // let paymentComplete;
              // if (validatePurchaseOnBackend(purchaseToken)) {
              //   paymentComplete = await paymentResponse.complete('success');
              //   // Let user know their purchase transaction has successfully completed and been verified
              // } else {
              //   paymentComplete = await paymentResponse.complete('fail');
              //   // Let user know their purchase transaction failed to verify
              // }

              // this.paymentComplete = paymentComplete;

              // service.consume(purchaseToken);
            case 28:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    }
  },
  data: function data() {
    return {
      monthlySale: false,
      showMonthlyMembership: true,
      monthlySelected: true,
      ResponseFromPurchase: null,
      error: null
      // showApps: false,
    };
  }
};